/* eslint-disable */

import { APIClient } from "./_api";
const endpoint = "/Inventory";

export function getAllFolder(query) {
  return APIClient.post(`${endpoint}Folder/filter`, query);
}

export function createInventoryFolder(data) {
  return APIClient.post(`${endpoint}Folder`, data);
}

export function deleteInventoryFolder(id) {
  return APIClient.delete(`${endpoint}Folder/${id}`);
}

export function editInventoryFolder(value, id) {
  return APIClient.put(`${endpoint}Folder/${id}`, value);
}

export function getAllItem(query) {
  return APIClient.post(`${endpoint}Item/filter`, query);
}

export function createInventoryItem(data) {
  return APIClient.post(`${endpoint}Item`, data);
}

export function editInventoryItem(data, id) {
  return APIClient.put(`${endpoint}Item/edit/${id}`, data);
}

export function getAllItemNoFilter() {
  return APIClient.get(`${endpoint}Item`);
}

export function getAllItemByOrderNum(orderNum) {
  return APIClient.get(`${endpoint}Item/order/orderNum/${orderNum}`);
}

export function getAllItemByOrderItem(orderItemId) {
  return APIClient.get(`${endpoint}Item/order/OrderItem/${orderItemId}`);
}

export function deleteInventoryItem(id) {
  return APIClient.delete(`${endpoint}Item/${id}`);
}

export function getItem(id) {
  return APIClient.get(`${endpoint}Item/id/${id}`);
}

export function getAllVendorType() {
  return APIClient.get(`${endpoint}Item/vendorType`);
}

export function uploadInvoice(values, func) {
  const bodyFormData = new FormData();
  for (const key in values) {
    bodyFormData.append(key, values[key]);
  }
  return APIClient.post(`${endpoint}Item/pdf`, bodyFormData, {
    onUploadProgress(progress) {
      if (func) {
        func(progress);
      }
    },
  });
}

export function handleInventoryToOrder(values, inventoryItemId) {
  return APIClient.put(`${endpoint}Item/exit/${inventoryItemId}`, values);
}

export function handleETAToOrder(values) {
  return APIClient.post(`${endpoint}Order/AddETA`, values);
}

export function handleEditInventory(values, inventoryItemId) {
  return APIClient.put(`${endpoint}Item/exitEdit/${inventoryItemId}`, values);
}
